<div class="campaign-option--live">
  <div class="campaign-option__container">
    <img class="campaign-option__image campaign-option__image--live" [src]="getImageUrl()" />
    <div class="campaign-option__info--live">
      <div class="w-100">
        <div class="campaign-option__name campaign-option__name--live">{{ option.name }}</div>
        <div class="campaign-option__count campaign-option__count--live">{{ available }}x available</div>
      </div>
      <div class="min-step">
        <div class="min-step__label text-truncate">{{ (getCurrentBid() === 0 ? 'Starting Bid': 'Next Bid Amount') }}</div>
        <div class="min-step__value text-truncate">{{ (getCurrentBid() === 0 ? option.minBid: getCurrentBid() + option.bidIncrement) | currency:'USD':'symbol-narrow':'1.0-0' }}</div>
      </div>
    </div>
  </div>
</div>
<div class="widget__separator"></div>
<div class="d-flex flex-sm-column flex-xl-row campaign-option__leader">
  <div class="d-flex align-items-center campaign-option__leader-info w-100">
    <ng-container *ngIf="leader">
      <app-icon-success *ngIf="leader.data.winningBid"></app-icon-success>
      <div class="campaign-option__leader-name">{{ leader.data.userInfo.name }}</div>
      <div *ngIf="!leader.data.winningBid" class="campaign-option__leader-text">has bid</div>
      <div *ngIf="leader.data.winningBid" class="campaign-option__leader-text">won the item for</div>
      <div class="campaign-option__leader-amount">{{ leader.data.amount | currency:'USD':'symbol-narrow':'1.0-0' }}</div>
      <div *ngIf="!leader.data.winningBid" class="campaign-option__leader-remove ml-1" (click)="removeBid(leader.data.id)">x</div>
    </ng-container>
  </div>
  <button
    class="btn btn--paybee btn--success btn--sm btn--declare-leader mt-sm-2 mt-xl-0 ml-xl-2"
    (click)="finalizeAuctionItem(campaign, option)"
    [disabled]="buttonDeclareWinnerDisabled"
  >{{buttonLabel}}</button>
  <button
    class="btn btn--paybee btn--pink btn--sm btn--sell-more mt-sm-2 mt-xl-0 ml-xl-2"
    (click)="showLiveAuctionMulti(campaign, option)"
    [disabled]="buttonSellMoreDisabled"
  >Sell More</button>
</div>